import React from 'react';
import { JcApp, JcAsyncErrorBoundary, JcRouter } from 'jcsdk';
import { hoopsAppRoutingConfig } from './routing/HoopsAppRoutingConfig';
import { HoopsAuthProvider } from './auth/HoopsAuthProvider';

export const HoopsApp = (): React.ReactElement => {
    return (
        <JcApp>
            <JcAsyncErrorBoundary>
                <HoopsAuthProvider>
                    <JcRouter config={hoopsAppRoutingConfig} />
                </HoopsAuthProvider>
            </JcAsyncErrorBoundary>
        </JcApp>
    );
};
